import React, { useState } from "react";
import styles from "./ChatBox.module.css";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Typography,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { processPamphlet } from "../../utlsLogic/pamphletProcessor";

const LeadFormBox = ({ onClose, onSubmit, formType, planData }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [newsletter, setNewsletter] = useState(true);
  const [processing, setProcessing] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async () => {
    if (!name || (formType === "Email" && !email) || (formType === "Whatsapp" && !phone)) {
      alert("Please fill all required fields");
      return;
    }

    const formData = {
      name,
      phone: formType === "Whatsapp" ? phone : "",
      email: formType === "Email" ? email : "",
      newsletter,
    };

    setProcessing(true);
    const result = await processPamphlet(formData, planData, formType);
    setProcessing(false);

    if (result) {
      setSuccess(true);
      onSubmit?.(formData); // original callback
    }
  };

  return (
    <div className={styles.chatBox}>
      <div className={styles.header}>
        <Typography variant="subtitle1" fontWeight="bold">
          {formType === "Whatsapp" ? "Share via WhatsApp" : "Send via Email"}
        </Typography>
        <CloseIcon onClick={onClose} className={styles.closeBtn} />
      </div>

      <Box className={styles.body} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {success ? (
          <Typography variant="body1" color="success.main">
            🎉 Pamphlet sent successfully to your {formType}!
          </Typography>
        ) : (
          <>
            <TextField
              label="Full Name"
              variant="outlined"
              size="small"
              value={name}
              onChange={(e) => setName(e.target.value)}
              fullWidth
              disabled={processing}
            />
            {formType === "Whatsapp" && (
              <TextField
                label="WhatsApp Number"
                variant="outlined"
                size="small"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                fullWidth
                disabled={processing}
              />
            )}
            {formType === "Email" && (
              <TextField
                label="Email"
                variant="outlined"
                size="small"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                fullWidth
                disabled={processing}
              />
            )}
            <FormControlLabel
              control={
                <Checkbox
                  checked={newsletter}
                  onChange={() => setNewsletter(!newsletter)}
                  color="primary"
                  disabled={processing}
                />
              }
              label="Stay connected via newsletter"
            />
          </>
        )}
      </Box>

      <div className={styles.footer}>
        {processing ? (
          <Button variant="outlined" fullWidth disabled>
            <CircularProgress size={20} sx={{ mr: 1 }} /> Sending...
          </Button>
        ) : success ? (
          <Button variant="contained" color="success" fullWidth onClick={onClose}>
            Done
          </Button>
        ) : (
          <Button variant="contained" color="primary" fullWidth onClick={handleSubmit}>
            Send Personalised Pamphlet
          </Button>
        )}
      </div>
    </div>
  );
};

export default LeadFormBox;
